export default function(s) {
  return s.match(/.{6}/g).map(function(x) {
    return "#" + x;
  });
}



//////////////////
// WEBPACK FOOTER
// ./~/vue-d3/~/d3-scale/src/colors.js
// module id = TSr9
// module chunks = 0